/**
 * This facet helpers will
 * be use only in debug mode
 */
if (document.querySelectorAll('.facetwp-facet').length > 0) {
  if (null === document.querySelector('.facetwp-template')) {
    console.warn(
      "Don't forget your class facetwp-template when adding facet filters to be able to display"
    );
  }
}
